import React, { useState } from 'react';
import './AddProjectModal.css';

const AddProjectModal = ({ isOpen, masterProjectId, onAdd, onCancel }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (title.trim()) {
      setIsSubmitting(true);
      try {
        await onAdd({
          title: title.trim(),
          description: description.trim(),
          masterProjectId
        });
        // Reset form
        setTitle('');
        setDescription('');
      } catch (error) {
        console.error('Error adding project:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleCancel = () => {
    if (!isSubmitting) {
      setTitle('');
      setDescription('');
      onCancel();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isSubmitting) {
      handleCancel();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="add-project-modal-backdrop" onClick={handleBackdropClick}>
      <div className="add-project-modal-content">
        <h2>Add New Project</h2>
        <form onSubmit={handleSubmit}>
          <div className="add-project-modal-field">
            <label htmlFor="project-title">Project Title *</label>
            <input
              id="project-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter project title"
              required
              autoFocus
              disabled={isSubmitting}
              maxLength={255}
            />
          </div>
          <div className="add-project-modal-field">
            <label htmlFor="project-description">Project Description</label>
            <textarea
              id="project-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter project description (optional)"
              rows={3}
              disabled={isSubmitting}
            />
          </div>
          <div className="add-project-modal-actions">
            <button 
              type="button" 
              onClick={handleCancel} 
              className="cancel-button"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="create-button"
              disabled={isSubmitting || !title.trim()}
            >
              {isSubmitting ? 'Creating...' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProjectModal;